import classnames from 'classnames';
import React, { CSSProperties } from 'react';

import styles from './ProgressBar.module.scss';

export interface ProgressBarProps
  extends Pick<CSSProperties, 'animationDuration' | 'animationDelay'> {
  isFrozen?: boolean;
  className?: string;
}

export const ProgressBar = ({
  isFrozen = false,
  animationDuration,
  animationDelay,
  className,
}: ProgressBarProps) => (
  <div className={classnames(styles.bar, className)}>
    <div
      data-testid="progress-line"
      className={styles.line}
      style={{
        animationDelay,
        animationDuration,
        animationPlayState: isFrozen ? 'paused' : undefined,
      }}
    />
  </div>
);
